import { FieldProps, Field } from 'formik';
import React from 'react';
import {
  FormPageInputItemSingleSelection,
  SingleSelectionProperty,
  FormPageInputData,
} from 'shared';
import { FormFieldProps } from '../shared';
import { SingleSelectionInput } from './SingleSelectionInput';
import { useSingleSelection } from './useSingleSelection';

type Props = FormFieldProps<SingleSelectionProperty>;

const Container: React.FC<
  Props & {
    fieldProps: FieldProps<FormPageInputItemSingleSelection, FormPageInputData>;
  }
> = ({ fieldProps, property, design, disabled, submitted }) => {
  const {
    fieldTouched,
    fieldErrorMessages,
    handleSelectChange,
    handleSubtextChange,
    handleSubtextBlur,
    parentValue,
  } = useSingleSelection({
    fieldProps,
    property,
  });

  if (fieldProps.field.value == null) {
    return null;
  }

  return (
    <SingleSelectionInput
      property={property}
      design={design}
      disabled={disabled}
      value={fieldProps.field.value}
      onSelectChange={handleSelectChange}
      onSubtextChange={handleSubtextChange}
      onSubtextBlur={handleSubtextBlur}
      errorMessages={fieldErrorMessages}
      touched={fieldTouched}
      submitted={submitted}
      parentValue={parentValue}
    />
  );
};

export const SingleSelection: React.FC<Props> = (props) => {
  return (
    <Field name={props.property.propertyId}>
      {(fieldProps: FieldProps<FormPageInputItemSingleSelection>) => (
        <Container {...props} fieldProps={fieldProps} />
      )}
    </Field>
  );
};
